import {isMobileOnly} from "react-device-detect";
import {Redirect, Route, Switch} from "react-router-dom";
import WebsiteMainLoginView from "@/Domains/AuthenticationManagement/WebsiteMainLoginView";
import WebsiteMainAppcodeView from "@/Domains/AuthenticationManagement/WebsiteMainAppcodeView";
import React, {useEffect} from "react";
import UserTokenMainQueryRenderer from "@/Domains/AuthenticationManagement/Usertoken/Queryrenderer/UserTokenMainQueryRenderer";
import {
    MainComponentQueryRendererQueryResponse
} from "@/Containers/__generated__/MainComponentQueryRendererQuery.graphql";
import {useTranslationModeSwitch} from "@/Utils/CustomHooks/useTranslationModeSwitch";


interface IWebsiteComponent {
    toggleComponents: () => void;
}
export default function WebsiteComponent({
    toggleComponents} : IWebsiteComponent) {
    if (isMobileOnly) {
        return <>Use Other device!</>;
    }
    const mode = useTranslationModeSwitch()
    useEffect(() => {
        toggleComponents();
    }, [mode,toggleComponents]);

    return (
        <Switch>
            <Route path="/login">
                <WebsiteMainLoginView/>
            </Route>
            <Route path="/appcode">
                <WebsiteMainAppcodeView/>
            </Route>
            <Route path="/user/create/:token">
                <UserTokenMainQueryRenderer/>
            </Route>
            <Route path="/">{<Redirect to="/login"/>}</Route>
        </Switch>
    );
}
